import { useState, useEffect } from 'react';
import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import HelperService from "../utility/HelperService";
import BsButton from "react-bootstrap/Button";
import { DashSquare, PencilFill, PlusSquare, Search, Trash3, Upload, XSquare } from "react-bootstrap-icons";
import { toast } from 'react-toastify';
import WebService from '../utility/WebService';
import Loader from '../Loader/Loader';
import { Label } from '../Label/Label';
import './EmailBlade.scss';

interface propData {
    data?: any;
    isShow: boolean;
    isClose: any;
    code: string;
    quoteNum: string;
}

const EmailBlade = (props: propData) => {
    const [emailData, setEmailData] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(false);
    const [comment, setComment] = useState<string>('');
    const [previewEmail, setPreviewEmail] = useState<any>()
    const [emailBody, setEmailBody] = useState<string>()

    useEffect(() => {
        if (props.isShow) {
            emailData.push({ email: props?.data?.smEmail, hasEmailValidate: false })
            setEmailData([...emailData])
        }
    }, [props.isShow])

    useEffect(() => {
        console.log("props.quoteNum", props.quoteNum)
        if (props.quoteNum) {
            getEmailPreview();
        }
    }, [props.isShow, props.quoteNum])

    const onCloseModal = (e?: any) => {
        setEmailData([])
        setComment('')
        props.isClose(!props.isShow, e)
    };

    const onAddNewOption = () => {
        emailData.push({ email: '', hasEmailValidate: false })
        setEmailData([...emailData])
    }

    const onRemoveOption = (index: number) => {
        if (emailData.length !== 1) {
            emailData.splice(index, 1)
            setEmailData([...emailData])
        }
    }

    const getEmailPreview = () => {
        console.log("test")
        WebService.postAPI({
            action: `api/Quote/email_preview`,
            body: {
                CompanyCode: props.code,
                QuoteNumber: props.quoteNum
            }
        })
            .then((res: any) => {
                setPreviewEmail(res.result)
                setEmailBody(res.result.body);
            })
            .catch((e) => {

            })
    }

    const onSendMail = () => {
        var array = [];
        var count = 0;
        var isShowError = false;
        for (var i in emailData) {
            array.push(emailData[i].email)
            if (emailData[i].email) {
                count = count + 1;
            }
            if (
                emailData[i].email &&
                !HelperService.isValidEmail(emailData[i].email)
            ) {
                emailData[i].hasEmailValidate = true;
                isShowError = true;
            }
        }
        if (isShowError == false) {
            setLoading(true)
            WebService.postAPI({
                action: `api/Quote/email`,
                body: {
                    CompanyCode: props.code,
                    QuoteNumber: props.quoteNum,
                    ToEmails: array,
                    comments: '<span style="white-space: pre-wrap;">' + comment + '</span>'
                },
            })
                .then((res: any) => {
                    setLoading(false)
                    toast.success(res.message)
                    onCloseModal()
                })
                .catch((e) => {
                    setLoading(false)
                    toast.error(e?.response?.data?.errorInfo?.message)

                })
        } else {
            toast.error('Please enter valid emails')
        }
        if (count == 0) {
            toast.error('Please enter valid emails')
        }
    }

    const onUpdatePreview = (value: any) => {
        previewEmail.body = emailBody;
        var cleanText = value.replace(/<\/?[^>]+(>|$)/g, "");
        previewEmail.body = previewEmail?.body.replaceAll('[Comments]', cleanText)
        setPreviewEmail({ ...previewEmail })
    }

    return (
        <>
            <Loader show={isLoading} />
            <Offcanvas
                show={props.isShow}
                onHide={onCloseModal}
                placement={"end"}
                className="offcanvas-large"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Email</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="border-bottom px-0 information-main-view ">
                    <div className="modal-body px-3 modal-inner-min-h email-blade">
                        {
                            emailData.map((res, index) => {
                                return (
                                    <div className='form-group mt-3 '>
                                        <InputGroup>
                                            <input className="form-control input" placeholder="Email" value={res.email}
                                                onKeyUp={(e: any) =>
                                                    HelperService.isValidEmail(e.target.value)
                                                }
                                                onChange={(e) => {
                                                    emailData[index].email = e.target.value
                                                    setEmailData([...emailData])
                                                }} />
                                            <BsButton
                                                variant="outline-secondary"
                                                id="button-addon2"
                                                onClick={() => onAddNewOption()}
                                            >
                                                <PlusSquare size={17} style={{ color: '#F55943' }} />
                                            </BsButton>
                                            {
                                                emailData.length !== 1 &&
                                                <BsButton
                                                    variant="outline-secondary"
                                                    id="button-addon2"
                                                    onClick={() => onRemoveOption(index)}
                                                >
                                                    <DashSquare size={17} style={{ color: '#F55943' }} />
                                                </BsButton>
                                            }
                                        </InputGroup>
                                    </div>
                                )
                            })
                        }
                        <div className='mt-2'>
                            <Label
                                title="Comment"
                                classNames="font-medium font-14 font-w-medium d-inline me-3 text-dark"
                            />
                            <textarea
                                className="form-control booknew-textarea h-auto"
                                rows={4}
                                value={comment}
                                onChange={(e: any) => {
                                    setComment(e.target.value)
                                    onUpdatePreview(e.target.value)
                                }}
                            />
                        </div>
                        <div className='mt-4'>
                            <Label
                                title="Preview Email"
                                classNames="font-medium font-14 font-w-medium d-inline me-3 text-dark"
                            />
                            <div dangerouslySetInnerHTML={{ __html: previewEmail?.body }} className='preview' />
                        </div>
                    </div>

                    <div className="offcanvas-footer mt-4  ">
                        <Button
                            variant="primary"
                            className="btn-brand-solid me-3"
                            type="submit"
                            onClick={() => onSendMail()}
                        >
                            Send
                        </Button>
                        <Button
                            variant="primary"
                            className="btn-brand-outline"
                            type="button"
                            onClick={onCloseModal}
                        >
                            Cancel
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EmailBlade;